import { render, staticRenderFns } from "./MainCodeBlock.vue?vue&type=template&id=ab6bf088&"
import script from "./MainCodeBlock.vue?vue&type=script&lang=js&"
export * from "./MainCodeBlock.vue?vue&type=script&lang=js&"
import style0 from "./MainCodeBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports